module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer full"
  }, [_c('section', {
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [_c('AdminTools'), _vm._v(" "), _c('ZoneList')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cf24b24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zone/Zones.vue
// module id = 3097
// module chunks = 0